import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DepreciationPreview  {
    _originalTypeClassName = "zERP.BO.DepreciationPreview";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DepreciationPreview.translate = translateService;
}
this.Assets = [];
this.Id = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Assets:any;
static setAssets = ($this, items) => {
                if (items == null) items = [];
                if ($this.Assets == null) $this.Assets = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Assets.length > 0) {
                    Domain.DepreciationPreview.removeAssets($this, $this.Assets[0]);
                }

                Domain.DepreciationPreview.addManyAssets($this, copyItems);
            }
static addManyAssets = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.DepreciationPreview.addAssets($this, items[i]);
                }
            }
static addAssets = ($this, item) => {
                if ($this.Assets == null) $this.Assets = [];
                if (item == null || $this.Assets.indexOf(item) > -1) return;
                $this.Assets.push(item);
}
static addRangeAssets = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.DepreciationPreview.addAssets($this, item));
            }
static removeAssets = ($this, item) => {
                if ($this == null || $this.Assets == null || $this.Assets.indexOf(item) === -1) return;
                var _index = $this.Assets.indexOf(item);
                $this.Assets.splice(_index, 1);
}
static clearAssets = ($this) => { $this.Assets = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}